import { render, staticRenderFns } from "./vorgaenge.vue?vue&type=template&id=05123a8b"
import script from "./vorgaenge.vue?vue&type=script&lang=js"
export * from "./vorgaenge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports